export default __webpack_public_path__ + "static/media/undraw_empty.67545509.svg";